import { z } from "zod/v3";
import { DateTime } from "luxon";
import { DisabledTrack, disabledTrackSchema } from "@opstel/query/models/disabledTrack";
import { createSchema, ZodOutputFor } from "@opstel/query/zod-utils";
import { PlainMessage, Timestamp } from "@bufbuild/protobuf";
import { BlockedInfrastructures as ProtoBlockedInfrastructures } from "@opstel/gen/knop/ui/v1/model/blocked_infrastructures_pb";

export interface BlockedInfrastructures {
  startTime: DateTime;
  endTime: DateTime;
  tracks: DisabledTrack[];
}

export const blockedInfrastructuresSchema = createSchema<
  BlockedInfrastructures,
  PlainMessage<ProtoBlockedInfrastructures>
>({
  startTime: z
    .instanceof(Timestamp, { message: "BlockedInfrastructures should have a start time" })
    .transform((val) => DateTime.fromJSDate(val.toDate())),
  endTime: z
    .instanceof(Timestamp, { message: "BlockedInfrastructures should have an end time" })
    .transform((val) => DateTime.fromJSDate(val.toDate())),
  tracks: z.array(disabledTrackSchema),
}) satisfies ZodOutputFor<BlockedInfrastructures>;
